module.exports = __webpack_public_path__ + "img/MOH kenya.964ee7c5.jpg";